export default __webpack_public_path__ + "static/media/prospect.0495ea21.png";